import { render, staticRenderFns } from "./examChapter.vue?vue&type=template&id=3e5d8114&"
import script from "./examChapter.vue?vue&type=script&lang=js&"
export * from "./examChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports